import { Recording as AntdRecording } from "@empglabs/backoffice-ui-kit"
import { forwardRef } from "react"

const Recording = forwardRef((props, ref) => {
  return <AntdRecording ref={ref} {...props} />
})

export default Recording
